import { cn } from "@omni/utils/styles";

const ACTIONS_ID = "sticky-actions";

let stickyActionsRoot: HTMLElement | null = null;

export const getStickyActionsRoot = () => {
    if (stickyActionsRoot) return stickyActionsRoot;

    stickyActionsRoot = document.createElement("div");
    stickyActionsRoot.id = ACTIONS_ID;
    stickyActionsRoot.className = cn(
        "tw:fixed tw:bottom-0 tw:left-0 tw:w-full tw:layer-overlay/[0] tw:flex tw:gap-2 tw:shadow-[0_3px_8px_rgba(0,0,0,0.24)] tw:md:shadow-none",
        "tw:p-2 tw:bg-background",
        "tw:md:px-4 tw:md:py-0 tw:md:bg-transparent",
        "tw:empty:hidden"
    );

    document.body.appendChild(stickyActionsRoot);

    return stickyActionsRoot;
};
